/* Shopify hand-off. The site stays the front end; payment happens in Shopify Checkout.
   To go live: paste the Storefront API access token from Shopify admin (Settings → Apps and sales channels →
   Headless → Storefront API) into TOKEN below. Until then checkout stays in demo mode. */
(function () {
  var K = window.KPS;
  var SHOP = "y1sh13-1r.myshopify.com";
  var TOKEN = ""; // Storefront API public access token
  var API = "2025-01";
  // Served by the Shopify theme: use the store's own cart, so no Storefront token is needed.
  var ON_SHOPIFY = !!(window.Shopify && window.Shopify.shop);

  // Site product key ("id|unit" or "id|box") → Shopify variant GID. From the KPS Shopify store, 27 Oct 2026.
  var VARIANTS = {
    "rigid12|unit": "gid://shopify/ProductVariant/53610351296693", "rigid12|box": "gid://shopify/ProductVariant/53610351329461",
    "rigid25|unit": "gid://shopify/ProductVariant/53610324787381", "rigid25|box": "gid://shopify/ProductVariant/53610324820149",
    "rigid38|unit": "gid://shopify/ProductVariant/53610313318581", "rigid38|box": "gid://shopify/ProductVariant/53610313351349",
    "rigid50|unit": "gid://shopify/ProductVariant/53610324885685", "rigid50|box": "gid://shopify/ProductVariant/53610324918453",
    "hts25|unit": "gid://shopify/ProductVariant/53610325016757", "hts25|box": "gid://shopify/ProductVariant/53610325049525",
    "hts50|unit": "gid://shopify/ProductVariant/53610325115061", "hts50|box": "gid://shopify/ProductVariant/53610325147829",
    "hts75|unit": "gid://shopify/ProductVariant/53610325213365", "hts75|box": "gid://shopify/ProductVariant/53610325246133",
    "hts25k|unit": "gid://shopify/ProductVariant/53610325344437", "hts25k|box": "gid://shopify/ProductVariant/53610325377205",
    "hts50k|unit": "gid://shopify/ProductVariant/53610325442741", "hts50k|box": "gid://shopify/ProductVariant/53610325475509",
    "hts75k|unit": "gid://shopify/ProductVariant/53610325541045", "hts75k|box": "gid://shopify/ProductVariant/53610325573813",
    "hts25b|unit": "gid://shopify/ProductVariant/53610351394997", "hts25b|box": "gid://shopify/ProductVariant/53610351427765",
    "hts50b|unit": "gid://shopify/ProductVariant/53610351526069", "hts50b|box": "gid://shopify/ProductVariant/53610351558837",
    "hts75b|unit": "gid://shopify/ProductVariant/53610351624373", "hts75b|box": "gid://shopify/ProductVariant/53610351657141",
    "heavy25|unit": "gid://shopify/ProductVariant/53610351722677", "heavy25|box": "gid://shopify/ProductVariant/53610351755445",
    "heavy50|unit": "gid://shopify/ProductVariant/53610351853749", "heavy50|box": "gid://shopify/ProductVariant/53610351886517",
    "heavy75|unit": "gid://shopify/ProductVariant/53610351952053", "heavy75|box": "gid://shopify/ProductVariant/53610351984821",
    "under50|unit": "gid://shopify/ProductVariant/53610325704885",
    "under100|unit": "gid://shopify/ProductVariant/53610325639349",
    "foamunder|unit": "gid://shopify/ProductVariant/53610352083125",
    "microfoam|unit": "gid://shopify/ProductVariant/53610352148661", "microfoam|box": "gid://shopify/ProductVariant/53610352181429",
    "orthofoam|unit": "gid://shopify/ProductVariant/53610352279733",
    "ktape|unit": "gid://shopify/ProductVariant/53610352574645",
    "prestrap|unit": "gid://shopify/ProductVariant/53610352640181", "prestrap|box": "gid://shopify/ProductVariant/53610352672949",
    "grip|unit": "gid://shopify/ProductVariant/53610352771253", "grip|box": "gid://shopify/ProductVariant/53610352804021",
    "glovesS|unit": "gid://shopify/ProductVariant/53610352869557",
    "glovesM|unit": "gid://shopify/ProductVariant/53610352902325",
    "glovesL|unit": "gid://shopify/ProductVariant/53610352935093",
    "boots|unit": "gid://shopify/ProductVariant/53610325835957",
    "metsal|unit": "gid://shopify/ProductVariant/53610353164469",
    "hydralyte|unit": "gid://shopify/ProductVariant/53610353230005",
    "pickle|unit": "gid://shopify/ProductVariant/53610353328309",
    "bumbag|unit": "gid://shopify/ProductVariant/53610325901493",
    "medbag|unit": "gid://shopify/ProductVariant/53610325967029",
    "largebag|unit": "gid://shopify/ProductVariant/53610326032565",
    "samplepack|unit": "gid://shopify/ProductVariant/53610355228853"
  };

  function gql(query, variables) {
    return fetch("https://" + SHOP + "/api/" + API + "/graphql.json", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": TOKEN },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); });
  }

  function ajax(path, body) {
    return fetch(path, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body || {}) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw { code: "api", message: j.description || j.message || "Shopify didn’t accept the cart" }; return j; }); });
  }

  K.shopify = {
    ready: function () { return ON_SHOPIFY || !!TOKEN; },
    variantFor: function (key) { return VARIANTS[key] || null; },
    // Builds a Shopify cart from the site's cart and returns the checkout URL.
    // Lines without a Shopify variant (enquiry products) are reported back instead of silently dropped.
    checkoutUrl: function (items, attrs) {
      var lines = [], missing = [];
      Object.keys(items || {}).forEach(function (k) {
        var q = items[k]; if (!q) return;
        var v = VARIANTS[k]; if (!v) { missing.push(k); return; }
        lines.push({ merchandiseId: v, quantity: q });
      });
      if (missing.length) return Promise.reject({ code: "missing", keys: missing });
      if (!lines.length) return Promise.reject({ code: "empty" });
      if (ON_SHOPIFY) {
        var items = lines.map(function (l) { return { id: Number(l.merchandiseId.split("/").pop()), quantity: l.quantity }; });
        return ajax("/cart/clear.js")
          .then(function () { return ajax("/cart/add.js", { items: items }); })
          .then(function () { return ajax("/cart/update.js", { note: (attrs && attrs.note) || "", attributes: (attrs && attrs.attributes) || {} }); })
          .then(function () { return "/checkout"; });
      }
      var input = { lines: lines };
      if (attrs && attrs.email) input.buyerIdentity = { email: attrs.email, countryCode: "AU" };
      if (attrs && attrs.note) input.note = attrs.note;
      if (attrs && attrs.attributes) input.attributes = Object.keys(attrs.attributes).map(function (k) { return { key: k, value: String(attrs.attributes[k]) }; });
      return gql("mutation($input: CartInput!) { cartCreate(input: $input) { cart { id checkoutUrl } userErrors { field message } } }", { input: input })
        .then(function (r) {
          var d = r && r.data && r.data.cartCreate;
          if (!d || !d.cart) throw { code: "api", message: (d && d.userErrors && d.userErrors[0] && d.userErrors[0].message) || (r.errors && r.errors[0] && r.errors[0].message) || "Shopify didn’t return a cart" };
          return d.cart.checkoutUrl;
        });
    }
  };
})();
